/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';

const TradeCalculations = ({
  lotSize,
  projectedLoss,
  projectedProfit,
  profitTarget,
  stopLossPrice,
  stopLossDistance,
}) => {
  return (
    <div className="space-y-1.5 text-[10px]">
      <div className="grid grid-cols-3 gap-x-3 gap-y-2">
        <div className="min-w-0 space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">Lot Size</p>
          <p className="font-mono text-sm font-semibold text-textPrimary">{lotSize}</p>
        </div>
        <div className="min-w-0 space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">SL</p>
          <p className="font-mono text-sm font-semibold text-textPrimary">{stopLossPrice}</p>
        </div>
        <div className="min-w-0 space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">TP</p>
          <p className="font-mono text-sm font-semibold text-textPrimary">{profitTarget}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-2 border-t border-borderDefault/20 pt-2">
        <div className="space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">Loss</p>
          <p className="font-mono text-sm font-semibold text-destructive">
            ${typeof projectedLoss === 'number' ? projectedLoss.toFixed(2) : '0.00'}
          </p>
        </div>
        <div className="space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">Profit</p>
          <p className="font-mono text-sm font-semibold text-success">
            ${typeof projectedProfit === 'number' ? projectedProfit.toFixed(2) : '0.00'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TradeCalculations;
